import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonneMoraleDirectorModificationContainer extends DivContainer {
	static className = "PersonneMoraleDirectorModificationContainer";
	
	static properties = {
		showReplacement: { type: Boolean, attribute: "show-replacement",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showRepresentative: { type: Boolean, attribute: "show-representative",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		},
		showRCSPlace: { type: Boolean, attribute: "show-rcs-place",
			converter: {
				fromAttribute: (value) => value === "true",
				toAttribute: (value) => (value ? "true" : "false"), 
			}
		}
	};

	constructor() {
    super();
	
	this.showReplacement = true;
	this.showRCSPlace = false;
	this.showRepresentative = false;
	
    this.content = () => html`
	  <row-wrapper>
		<select-from-api label="Qualité *" name="id_director_type" api-url="${window.APP_URL.api.directorType}" required value="0" null-option-text="Choisir une nature" null-option-value="0" name="id_director_type"></select-from-api>
      </row-wrapper>
      <row-wrapper>
        <text-field label="Dénomination *" required name="denomination"></text-field>
      </row-wrapper>
      <row-wrapper>
        <select-from-api
          label="Forme juridique *"
          api-url="${window.APP_URL.api.legalForm}"
          required
          value="0"
          null-option-text="Forme Juridique"
          null-option-value="0"
		  name="id_legal_form"
		  discard-legal-form="true"
        ></select-from-api>
      </row-wrapper>
      <row-wrapper>
        <text-field label="Adresse *" required name="address"></text-field>
      </row-wrapper>
      <autocomplete-ville></autocomplete-ville>
	  ${this.showRCSPlace ? html`
      <row-wrapper>
        <text-field label="Lieu d'immatriculation (RCS) *" required name="registration_location"></text-field>
      </row-wrapper>
	  ` : ""}
      <rcs-number-field label="Numéro de RCS *" required></rcs-number-field>
	  <row-with-tooltip tooltip-text="La ville du greffe dépend de l'adresse de siège social.">
	  	<text-field label="Greffe *" required name="greffe"></text-field>
	  </row-with-tooltip>
	  ${this.showRCSPlace ? html`
	  <row-with-tooltip tooltip-text="Indiquer la civilité (M./Mme/Melle), le(s) prénom(s) et le nom.">
	  	<text-field label="Nom du représentant" required name="representantive"></text-field>
	  </row-with-tooltip>
	  <row-with-tooltip tooltip-text="Indiquer l'adresse complète, code postal et ville.">
	  	<text-field label="Adresse complète du représentant" required name="representative_address"></text-field>
	  </row-with-tooltip>
	  ` : ""}
	  ${this.showReplacement ? html`
	  <row-with-tooltip tooltip-text="Si personne physique, indiquer la civilité (M./Mme/Melle), le prénom et le nom. Si société, indiquer la dénomination sociale">
	  	<text-field label="En remplacement de *" required name="replacement"></text-field>
	  </row-with-tooltip>
	  ` : ""}
    `;
  	}
	
	isTransient (){
		return false;
	}
}

customElements.define ("personne-morale-director-modification", PersonneMoraleDirectorModificationContainer);
